export default __webpack_public_path__ + "static/media/Group 18.325ad2db.png";